import React, { Fragment } from 'react'
import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'
import './hero17.css'

const Hero17 = (props) => {
  return (
    <div className="hero17-header78">
      <div className="hero17-column thq-section-padding thq-section-max-width">
        <div className="hero17-content1">
          <h1>
            {props.heading1 ?? (
              <Fragment>
                <h1 className="hero17-text4 thq-heading-1">
                  Empowering AI Innovation Across the Commonwealth
                </h1>
              </Fragment>
            )}
          </h1>
          <p>
            {props.content1 ?? (
              <Fragment>
                <p className="hero17-text3 thq-body-large">
                  Join us in shaping the future of AI by collaborating with
                  governments, industries, and academia to drive innovation,
                  economic growth, and societal benefits.
                </p>
              </Fragment>
            )}
          </p>
        </div>
      </div>
      <div className="hero17-content2">
        <div className="hero17-row-container1 thq-animated-group-container-horizontal thq-mask-image-horizontal">
          <div className="thq-animated-group-horizontal">
            <img alt={props.image1Alt} src="/1.jpg" className="hero17-placeholder-image10 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image2Alt} src="/2.jpg" className="hero17-placeholder-image11 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image3Alt} src="/3.jpg" className="hero17-placeholder-image12 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image4Alt} src="/4.jpg" className="hero17-placeholder-image13 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image5Alt} src="/5.jpg" className="hero17-placeholder-image14 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image6Alt} src="/6.jpg" className="hero17-placeholder-image15 thq-img-ratio-1-1 thq-img-scale" />
          </div>
          <div className="thq-animated-group-horizontal">
            <img alt={props.image1Alt} src="/7.jpg" className="hero17-placeholder-image16 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image2Alt} src="/8.jpg" className="hero17-placeholder-image17 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image3Alt} src="/9.jpg" className="hero17-placeholder-image18 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image4Alt} src="/10.jpg" className="hero17-placeholder-image19 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image5Alt} src="/11.jpg" className="hero17-placeholder-image20 thq-img-ratio-1-1 thq-img-scale" />
            <img alt="Hero Image" src="/12.jpg" className="hero17-placeholder-image21 thq-img-ratio-1-1 thq-img-scale" />
          </div>
        </div>
        <div className="hero17-row-container2 thq-animated-group-container-horizontal thq-mask-image-horizontal">
          <div className="thq-animated-group-horizontal-reverse">
            <img alt={props.image7Alt} src="/13.jpg" className="hero17-placeholder-image22 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image8Alt} src="/14.jpg" className="hero17-placeholder-image23 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image9Alt} src="/15.jpg" className="hero17-placeholder-image24 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image10Alt} src="/16.jpg" className="hero17-placeholder-image25 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image11Alt} src="/17.jpg" className="hero17-placeholder-image26 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image12Alt} src="/18.jpg" className="hero17-placeholder-image27 thq-img-ratio-1-1 thq-img-scale" />
          </div>
          <div className="thq-animated-group-horizontal-reverse">
            <img alt={props.image7Alt} src="/19.jpg" className="hero17-placeholder-image28 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image8Alt} src="/20.jpg" className="hero17-placeholder-image29 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image9Alt} src="/21.jpg" className="hero17-placeholder-image30 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image10Alt} src="/22.jpg" className="hero17-placeholder-image31 thq-img-ratio-1-1 thq-img-scale" />
            <img alt={props.image11Alt} src="/23.jpg" className="hero17-placeholder-image32 thq-img-ratio-1-1 thq-img-scale" />
            <img alt="Hero Image" src="/24.jpg" className="hero17-placeholder-image33 thq-img-ratio-1-1 thq-img-scale" />
          </div>
        </div>
      </div>
      <div>
        <div className="hero17-container2">
          <Script
            html={`<style>
  @keyframes scroll-x {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(calc(-100% - 16px));
    }
  }

  @keyframes scroll-y {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(calc(-100% - 16px));
    }
  }
</style>
`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

Hero17.defaultProps = {
  image6Alt: 'Hero Image',
  image7Alt: 'Hero Image',
  image4Alt: 'Hero Image',
  content1: undefined,
  image8Alt: 'Hero Image',
  image10Alt: 'Hero Image',
  image1Alt: 'Hero Image',
  image10Src: '/22.jpg',
  image9Alt: 'Hero Image',
  image5Alt: 'Hero Image',
  image4Src: '/10.jpg',
  image11Alt: 'Hero Image',
  image12Alt: 'Hero Image',
  image3Alt: 'Hero Image',
  heading1: undefined,
  image2Alt: 'Hero Image',
  image11Src: '/23.jpg',
}

Hero17.propTypes = {
  image6Alt: PropTypes.string,
  image7Alt: PropTypes.string,
  image4Alt: PropTypes.string,
  content1: PropTypes.element,
  image8Alt: PropTypes.string,
  image10Alt: PropTypes.string,
  image1Alt: PropTypes.string,
  image10Src: PropTypes.string,
  image9Alt: PropTypes.string,
  image5Alt: PropTypes.string,
  image4Src: PropTypes.string,
  image11Alt: PropTypes.string,
  image12Alt: PropTypes.string,
  image3Alt: PropTypes.string,
  heading1: PropTypes.element,
  image2Alt: PropTypes.string,
  image11Src: PropTypes.string,
}

export default Hero17
